import script from "./ProductCartList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCartList.vue?vue&type=script&setup=true&lang=js"

import "./ProductCartList.vue?vue&type=style&index=0&id=21fe2970&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21fe2970"]])

export default __exports__